import request from '../utils/request';
import Axios from 'axios';

// available params: limit, page, search, filters, sort_order, sort_direction
export const getProducts = ({ params = {} }) => {
  return request({
    url: '/products',
    method: 'GET',
    params,
  });
};

export const getProductsElasticSearch = ({ params = {} }) => {
  return request({
    url: '/products/elasticSearch',
    method: 'GET',
    params,
  });
};

// available params: page, pageSize, search
export const getProductsBrands = ({ params = {} }) => {
  return request({
    url: '/products/brands',
    method: 'GET',
    params,
  });
};

// available params: archived, available
// Note: This now uses the unified v1 search API (clientbook-api) which returns all categories at once (no pagination)
export const getProductsCategories = ({ params = {} }) => {
  // Convert GET params to POST body with defaults
  const body = {
    archived: params.archived ?? false,
    available: params.available ?? true,
  };

  // Get auth token from localStorage for Bearer authentication
  const jwtToken = localStorage.getItem('jwtToken');

  return Axios({
    method: 'POST',
    url: `${process.env.REACT_APP_CLIENTBOOK_API_URL}/api/v1/searches/products/categories`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${jwtToken}`,
    },
    data: body,
  }).then(response => {
    // Adapt response to maintain backward compatibility with existing consumers
    // New API returns: { total: number, data: [{ name: string, count: number }] }
    // Old API returned: { results: string[], page, pageSize, pages, total }
    return {
      data: {
        results: response.data.data.map(item => item.name),
        page: 1,
        pageSize: response.data.total,
        pages: 1,
        total: response.data.total,
      }
    };
  }).catch(error => {
    // Treat 404 as "no categories found" instead of an error
    if (error.response && error.response.status === 404) {
      return {
        data: {
          results: [],
          page: 1,
          pageSize: 0,
          pages: 0,
          total: 0,
        }
      };
    }
    // Re-throw other errors
    throw error;
  });
};

export const getProductById = id => {
  return request({
    url: `/products/${id}`,
    method: 'GET',
  });
};

export const deleteProductById = id => {
  return request({
    url: `/products/${id}`,
    method: 'DELETE',
  });
};

export const createProduct = data => {
  return request({
    url: '/products',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

export const updateProduct = (id, data) => {
  return request({
    url: `/products/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};
